// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { message, Modal, Tag } from 'antd'
import { get, includes, toNumber, defaultTo, isNil, map } from 'lodash'

// Ressources
import { actions as basinActions } from 'Resources/BasinResource'
import { actions as siteActions } from 'Resources/SiteResource'

// Common components
import { TableLayout, ManageModal } from 'Components'

// Styles
import './BasinsScreen.less'

const { confirm } = Modal

class BasinsScreen extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // DonnÃ©es de la vue
    basin: PropTypes.object,
    basins: PropTypes.array,
    sites: PropTypes.array,

    // TÃ©moin d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isCreating: PropTypes.bool,

    // Structure du tableLayout
    table: PropTypes.object,

    // Structure de la manageModal
    manageModal: PropTypes.object,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // DonnÃ©es de la vue
    basin: {},
    basins: [],
    sites: [],

    // TÃ©moin d'activitÃ© API
    isGathering: false,
    isUpdating: false,
    isCreating: false,

    // Structure du tableLayout
    table: {
      // Actions groupÃ©es
      actions: {
        global: {
          create: {
            label: 'common.create',
            icon: 'plus'
          }
        },
        selection: {
          // archive: {
          //   buttonType: 'danger'
          // },
          // update: {
          //   buttonType: 'primary'
          // },
          delete: {
            buttonType: 'danger'
          }
        }
      },

      // Gestion de l'internationalisation
      locale: {
        emptyText: 'pages.basins.table.empty'
      },

      // Gestion de la pagination
      pagination: {
        position: 'both',
        showSizeChanger: true,
        pageSizeOptions: ['10', '25', '50', '100']
      },

      // Identifiant unique de chaque ligne du tableau
      rowKey: 'id',

      // Colonnes du tableau
      columns: {
        name: {
          title: 'pages.basins.table.columns.name.title',
          dataIndex: 'name',
          key: 'name',
          sorter: (a, b) =>
            defaultTo(get(a, 'name'), '').localeCompare(
              defaultTo(get(b, 'name'), '')
            ),
          defaultSortOrder: 'ascend'
        },
        surface: {
          title: 'pages.basins.table.columns.surface.title',
          dataIndex: 'surface',
          key: 'surface',
          render: surface =>
            !isNil(surface)
              ? `${defaultTo(surface, 0).toLocaleString()} mÂ²`
              : I18n.t('common.none.female'),
          sorter: (a, b) =>
            defaultTo(get(a, 'surface'), 0) - defaultTo(get(b, 'surface'), 0)
        },
        overflowVolume: {
          title: 'pages.basins.table.columns.overflowVolume.title',
          dataIndex: 'overflowVolume',
          key: 'overflowVolume',
          render: overflowVolume =>
            !isNil(overflowVolume)
              ? `${defaultTo(overflowVolume, 0).toLocaleString()} mÂ³`
              : I18n.t('common.none.male'),
          sorter: (a, b) =>
            defaultTo(get(a, 'overflowVolume'), 0) -
            defaultTo(get(b, 'overflowVolume'), 0)
        },
        site: {
          title: 'pages.basins.table.columns.site.title',
          dataIndex: 'site',
          key: 'site',
          render: site => (
            <Tag color={isNil(get(site, 'name')) ? 'orange' : 'lime'}>
              {defaultTo(get(site, 'name'), I18n.t('common.none.male'))}
            </Tag>
          ),
          sorter: (a, b) =>
            defaultTo(get(a, 'site.name'), '').localeCompare(
              defaultTo(get(b, 'site.name'), '')
            )
        }
      }
    },

    // Structure de la manageModal
    manageModal: {
      title: {
        update: 'pages.basins.modal.update.single.title',
        create: 'pages.basins.modal.create.single.title'
      },
      okText: {
        update: 'pages.basins.modal.update.single.okText',
        create: 'pages.basins.modal.create.single.okText'
      },
      actions: {
        delete: {
          buttonType: 'danger'
        }
      },
      rows: {
        name: {
          title: 'pages.basins.modal.rows.name.title',
          dataIndex: 'name',
          key: 'name',
          formField: {
            label: 'pages.basins.modal.rows.name.title',
            required: 'pages.basins.modal.rows.name.requiredMessage',
            placeholder: 'pages.basins.modal.rows.name.placeholder'
          }
        },
        surface: {
          title: 'pages.silos.modal.rows.surface.title',
          dataIndex: 'surface',
          key: 'surface',
          formField: {
            label: 'pages.silos.modal.rows.surface.title',
            required: 'pages.silos.modal.rows.surface.requiredMessage',
            placeholder: 'pages.silos.modal.rows.surface.placeholder',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message: 'pages.silos.modal.rows.surface.patternMessage'
            },
            addonAfter: 'mÂ²',
            format: surface => (!isNil(surface) ? toNumber(surface) : undefined)
          }
        },
        overflowVolume: {
          title: 'pages.silos.modal.rows.overflowVolume.title',
          dataIndex: 'overflowVolume',
          key: 'overflowVolume',
          formField: {
            label: 'pages.silos.modal.rows.overflowVolume.title',
            required: 'pages.silos.modal.rows.overflowVolume.requiredMessage',
            placeholder: 'pages.silos.modal.rows.overflowVolume.placeholder',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message: 'pages.silos.modal.rows.overflowVolume.patternMessage'
            },
            addonAfter: 'mÂ³',
            format: overflowVolume =>
              !isNil(overflowVolume) ? toNumber(overflowVolume) : undefined
          }
        },
        site: {
          title: 'pages.basins.modal.rows.site.title',
          dataIndex: 'site',
          key: 'site',
          formField: {
            type: 'searchSelect',
            label: 'pages.basins.modal.rows.site.title',
            required: 'pages.silos.modal.rows.site.requiredMessage',
            placeholder: 'pages.basins.modal.rows.site.placeholder',
            format: site => get(site, 'id')
          }
        }
      }
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: null
    }
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
    this.fetchBasinsData()

    // RÃ©cupÃ©ration des donnÃ©es des sites pour association dans modale
    this.fetchSitesData()
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
   */
  fetchBasinsData = () => {
    this.props.actions.fetchBasins().catch(() => {
      message.error(I18n.t('api.errors.basin.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des sites pour association dans modale
   */
  fetchSitesData = () => {
    this.props.actions.fetchSites().catch(() => {
      message.error(I18n.t('api.errors.site.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'un Ã©lÃ©ment de la vue
   */
  getBasinData = basin =>
    new Promise((resolve, reject) => {
      this.props.actions
        .getBasin(basin)
        .then(response => {
          // DÃ©tails rÃ©cupÃ©rÃ©s
          resolve(get(response, 'body'), response)
        })
        .catch(error => {
          // Erreur lors du refresh
          reject(error)
          message.error(I18n.t('api.errors.basin.get'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Archivage de plusieurs lignes du tableau
   */
  archiveBasins = (basins, clearTableSelections) => {
    this.props.actions
      .archiveBasins(basins)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.basin.bulk.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.basin.bulk.archive'))
      })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveBasin = basin => {
    this.props.actions
      .archiveBasin(basin)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.basin.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.basin.archive'))
      })
  }

  /**
   * Actions groupÃ©e:
   * Suppression de plusieurs lignes du tableau
   */
  deleteBasins = (basins, clearTableSelections) => {
    this.props.actions
      .deleteBasins(basins)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.basin.bulk.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.basin.bulk.delete'))
      })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteBasin = basin => {
    this.props.actions
      .deleteBasin(basin)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.basin.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.basin.delete'))
      })
  }

  /**
   * Mise Ã  jour d'un basin
   */
  updateBasin = (updatedBasin, originalBasin) =>
    new Promise((resolve, reject) => {
      this.props.actions
        .updateBasin({ id: get(originalBasin, 'id'), ...updatedBasin })
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.basin.update'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.basin.update'))
        })
    })

  /**
   * CrÃ©ation d'un basin
   */
  createBasin = createdBasin =>
    new Promise((resolve, reject) => {
      this.props.actions
        .createBasin(createdBasin)
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.basin.create'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.basin.create'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askArchiveBasins = (...params) => {
    confirm({
      title: I18n.t('pages.basins.modal.archive.multiple.title'),
      content: I18n.t('pages.basins.modal.archive.multiple.content'),
      okText: I18n.t('pages.basins.modal.archive.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.basins.modal.archive.multiple.cancelText'),
      onOk: () => {
        this.archiveBasins(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askArchiveBasin = () => {
    const basin = get(this.props, 'basin')

    confirm({
      title: I18n.t('pages.basins.modal.archive.single.title'),
      content: I18n.t('pages.basins.modal.archive.single.content'),
      okText: I18n.t('pages.basins.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.basins.modal.archive.single.cancelText'),
      onOk: () => {
        this.archiveBasin(basin)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askDeleteBasins = (...params) => {
    confirm({
      title: I18n.t('pages.basins.modal.delete.multiple.title'),
      content: I18n.t('pages.basins.modal.delete.multiple.content'),
      okText: I18n.t('pages.basins.modal.delete.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.basins.modal.delete.multiple.cancelText'),
      onOk: () => {
        this.deleteBasins(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askDeleteBasin = () => {
    const basin = get(this.props, 'basin')

    confirm({
      title: I18n.t('pages.basins.modal.delete.single.title'),
      content: I18n.t('pages.basins.modal.delete.single.content'),
      okText: I18n.t('pages.basins.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.basins.modal.delete.single.cancelText'),
      onOk: () => {
        this.deleteBasin(basin)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Ouverture de la modale de modifications
   */
  openModal = (creating = true) => {
    this.setState({ openedModal: creating ? 'createBasin' : 'updateBasin' })
  }

  /**
   * Fermeture de toutes les modales
   */
  handleCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateBasin') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(this.setState({ openedModal: null }), 200)
      })
    } else {
      this.setState({ openedModal: null })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleBasinCreated = () => {
    this.handleCloseModal()
  }

  /**
   * Clic sur une ligne du tableau
   */
  handleRowClick = basin => {
    this.getBasinData(basin)
    this.setState({ openedModal: 'updateBasin' })
  }

  render() {
    const {
      table,
      isGathering,
      manageModal,
      isUpdating,
      isCreating,
      basins,
      basin,
      sites
    } = this.props
    const { openedModal } = this.state

    // GESTION DES TABLEAUX

    // Ajout des donnÃ©es au tableau
    table.rows = basins

    // Ajout des actions au clic sur un ligne du tableau
    table.onRow = (basin, id) => ({
      onClick: () => this.handleRowClick(basin, id)
    })

    // Ajout des actions multiples sur le tableau
    // table.actions.selection.archive.onClick = this.askArchiveBasins
    table.actions.selection.delete.onClick = this.askDeleteBasins
    // table.actions.selection.update.onClick = this.askUpdateBasins

    // GESTION DES BOUTONS

    // Ajout des actions des boutons
    table.actions.global.create.onClick = this.openModal

    // GESTION DE LA MODALE DE GESTION

    // Ajout des actions sur la modale
    manageModal.actions.delete.onClick = this.askDeleteBasin

    // Ajout des options pour le choix d'un site
    manageModal.rows.site.formField.options = map(sites, site => ({
      id: get(site, 'id'),
      label: get(site, 'name'),
      disabled: false,
      value: get(site, 'id')
    }))

    // GESTION DES LOADERS
    const loading = isGathering || isUpdating || isCreating

    return (
      <main className='screen basins'>
        {/* Affichage des donnÃ©es de la page */}
        <TableLayout
          elementName='basin'
          elementKind='female'
          elementConsonant
          loading={loading}
          {...table}
        />

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          loading={loading}
          onCancel={this.handleCloseModal}
          onOk={this.handleBasinCreated}
          onChange={
            openedModal === 'updateBasin' ? this.updateBasin : this.createBasin
          }
          visible={includes(['createBasin', 'updateBasin'], openedModal)}
          data={
            includes(['transition', 'updateBasin'], openedModal) ? basin : null
          }
          {...manageModal}
        />
      </main>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(BasinsScreen, 'defaultProps', {})

  return {
    basin: defaultTo(get(state, 'basin.item'), defaultProps.basin),
    basins: defaultTo(get(state, 'basin.items'), defaultProps.basins),
    sites: defaultTo(get(state, 'site.items'), defaultProps.sites),
    isGathering:
      defaultTo(get(state, 'basin.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'site.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'basin.isFetchingItem'), defaultProps.isGathering),
    isUpdating: defaultTo(
      get(state, 'basin.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...basinActions, ...siteActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BasinsScreen)
